import * as React from "react";
import type { SVGProps } from "react";
const SvgFileCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.3 21.6H5.5a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v6.6m-4.8 6.8 2.2 2.2 4.8-4.8M7.3 7.2h7.2m-7.2 3.6h7.2m-7.2 3.6h3.6"
    />
  </svg>
);
export default SvgFileCheck02;
